import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface InfoTooltipProps {
  title: string;
  description: string;
  iconSize?: number;
}

export function InfoTooltip({
  title,
  description,
  iconSize = 16,
}: InfoTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <HelpCircle
            className="text-gray-400 cursor-pointer"
            width={iconSize}
            height={iconSize}
          />
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p className="font-semibold">{title}</p>
          <p>{description}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
